import { render, staticRenderFns } from "./TransferZone.vue?vue&type=template&id=3e94926b&"
import script from "./TransferZone.vue?vue&type=script&lang=js&"
export * from "./TransferZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports